import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from './FormError';
import InputField from './InputField';
import SelectField from './SelectField';
import { toInt } from 'helpers/normalizers';

const StartSwitchFormSprintToAtt = ({
  handleSubmit,
  initialValues,
  subId,
  errorMsg,
  successMsg,
  attPlans,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field
        component={InputField}
        name="icc_id"
        label="Icc ID*"
        value={initialValues.icc_id}
      />
      <Field
        component={InputField}
        name="device_id"
        label="Device ID*"
        value={initialValues.device_id}
      />
      <Field
        component={SelectField}
        name="plan_id"
        label="AT&T Plan*"
        empty="Choose a plan"
        options={attPlans.map((plan) => [
          plan.id,
          `${plan.name} ${plan.price}`,
        ])}
        normalize={toInt}
      />
      {errorMsg && <FormError error={errorMsg} />}
      <button className="btn btn-default">Start Switch</button>
      <br />
      {successMsg && (
        <React.Fragment>
          <p className="text-success">{successMsg}</p>
        </React.Fragment>
      )}
    </form>
  </div>
);

const validate = (values) => {
  let errors = {};

  if (!values.icc_id) {
    errors.icc_id = 'Required';
  }
  if (!values.plan_id) {
    errors.plan_id = 'Required';
  }
  if (!values.device_id) {
    errors.device_id = 'Required';
  }
  if (!values.plan) {
    errors.plan = 'Required';
  }
  return errors;
};

export default reduxForm({
  form: 'sprintToAttStartSwitch',
  validate,
})(StartSwitchFormSprintToAtt);
